/**
 * Constants for unified channel logo components
 */

import { LogoSize, ChannelLogoType } from './types';

/** Standardized logo sizes in pixels */
export const LOGO_SIZES: Record<LogoSize, number> = {
  xs: 18,   // Inside small containers (SelectUnitsModal)
  sm: 24,   // Tables, lists, badges
  md: 38,   // Avatars, modals
  lg: 48,   // Page headers
  xl: 70,   // Main displays, cards
};

/** Default background colors for each channel */
export const CHANNEL_BACKGROUNDS: Record<ChannelLogoType, string> = {
  msool: '#5B3FFF',
  airbnb: '#FF5A5F',
  booking: '#003B95',
  gathern: '#331860',
};

/** Light background colors for channel containers */
export const CHANNEL_LIGHT_BACKGROUNDS: Record<ChannelLogoType, string> = {
  msool: '#5B3FFF',
  airbnb: '#FF5A5F',
  booking: '#003B95',
  gathern: '#331860',
};

/** Border radius values */
export const BORDER_RADIUS = {
  rounded: '50%',
  default: '16px',
  small: '8px',
};
